<template>
	<QrcodeNavShell
		variant="gradient"
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import QrcodeNavShell from '../shared/QrcodeNavShell.vue';
	import { qrcodeNavMixin } from '../shared/mixin.js';

	export default {
		name: 'GBlockQrcodeNavGradient',
		components: { QrcodeNavShell },
		mixins: [qrcodeNavMixin],
	};
</script>
